module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//24.jpg?42785c14607b7655425a07863c912045";